define.alias("shared/models/linkedin-post", "calendar/models/linkedin-post");